module.exports = __webpack_public_path__ + "img/ic_check_white.62f7a860.svg";